import React, { createContext, useContext, useState, ReactNode } from 'react';

type Account = {
    id: string;
    name: string;
    email: string;
    // Add more fields as needed
};


type AccountContextType = {
    account: Account | null;
    notVisibleList: string[];
    setNotVisibleList: (visibleList: string[]) => void;
    setAccount: (account: Account | null) => void;
};

const AccountContext = createContext<AccountContextType | undefined>(undefined);

export const AccountProvider = ({ children }: { children: ReactNode }) => {
    const [account, setAccount] = useState<Account | null>(null);
    const [notVisibleList, setNotVisibleList] = useState<string[]>(
        () => JSON.parse(localStorage.getItem('notVisibleList') || '[]')
    );

    React.useEffect(() => {
        localStorage.setItem('notVisibleList', JSON.stringify(notVisibleList));
    }, [notVisibleList]);

    return (
        <AccountContext.Provider value={{ account, setAccount , notVisibleList, setNotVisibleList }}>
            {children}
        </AccountContext.Provider>
    );
};

export const useAccount = () => {
    const context = useContext(AccountContext);
    if (!context) {
        throw new Error('useAccount must be used within an AccountProvider');
    }
    return context;
};